const CopyToClipBoard = (content) => {
    navigator.clipboard.writeText(content);
  }
export default CopyToClipBoard;